export interface ContactgegevensQueryParams {
    action: ContactgegevensAction | string;
    phonenumber?: string;
}

export enum ContactgegevensAction {
    VALIDATE = 'VALIDATE',
    NEW_PHONE_NUMBER = 'NEW',
    CHANGE_PHONE_NUMBER = 'CHANGEPHONENUMBER',
    NONE = 'NONE'
}
